import PropTypes from "prop-types";

import { Table } from "components/Table";
import { Button } from "components/Button";
import { tradeColumns } from "./columns";
import { useNavigation } from "utils/navigate";
import { Title } from "style/components/Title.styles";

const CSV_HEADERS = ["Asset", "Side", "Quantity", "Price", "Date"];
const CSV_FIELDS = ["asset", "side", "qty", "price", "date"];

const downloadCSV = (data) => {
  const escape = (v) => {
    const s = v == null ? "" : String(v);
    return s.includes(",") || s.includes('"') || s.includes("\n")
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };
  const rows = [
    CSV_HEADERS.join(","),
    ...data.map((row) => CSV_FIELDS.map((f) => escape(row[f])).join(",")),
  ];
  const blob = new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "trades.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const Trades = ({ data = [], isLoading, isPublicStrategy }) => {
  const { navigateToV2StockDetails } = useNavigation();

  const handleRowClick = (selected) => {
    if (!isPublicStrategy) {
      navigateToV2StockDetails(selected.asset);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mt-0 mb-0">
        <Title className="mb-0">Trades</Title>
        <Button
          variant="outlined"
          size="small"
          label="Download CSV"
          disabled={!data.length || isLoading}
          onClick={() => downloadCSV(data)}
        />
      </div>
      <div className="divider mt-3 mb-0"></div>
      <div className="trades-table">
        <Table
          data={data}
          isLoading={isLoading}
          columns={tradeColumns}
          initialPageSize={15}
          onRowClick={handleRowClick}
          showPagination={false}
        />
      </div>
    </>
  );
};

Trades.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.array,
  isPublicStrategy: PropTypes.bool,
};
